// ------------------------------------
// Máscaras
// ------------------------------------
initInputMask();
function initInputMask() {
  // Numérico
  $('.number').mask('#');

  // Valor
  //$('.money').mask('#.##0,00', { reverse: true });
  $('.money').each(function () {
    const allowZero = !$(this).prop('required') ? false : true;
    $(this)
      .maskMoney({
        thousands: '.',
        decimal: ',',
        allowZero: allowZero,
      })
      .on('change', function () {
        $(this).parsley().validate();
      });
  });

  // Endereço de IP
  $('.ip_address').mask('0ZZ.0ZZ.0ZZ.0ZZ', { translation: { Z: { pattern: /[0-9]/, optional: true } } });

  // Data
  $('.date').mask('00/00/0000', { clearIfNotMatch: true });
  $('.date_time').mask('00/00/0000 00:00:00', { clearIfNotMatch: true });

  // Horário
  $('.time').mask('00:00', { clearIfNotMatch: true });

  // CEP
  $('.cep').mask('00000-000', { clearIfNotMatch: true });

  // Cartão de crédito
  $('.card-number').mask('0000 0000 0000 0000');

  // Validade do cartão de crédito
  $('.card-date').mask('00/00', { clearIfNotMatch: true });

  // CPF
  $('.cpf').mask('000.000.000-00', { clearIfNotMatch: true, reverse: true });

  // CNPJ
  $('.cnpj').mask('00.000.000/0000-00', { clearIfNotMatch: true, reverse: true });

  // CPF OU CNPJ
  const maskCpfCnpj = function (val) {
    return val.replace(/\D/g, '').length > 11 ? '00.000.000/0000-00' : '000.000.000-009';
  };
  const optMaskCpfCnpj = {
    onKeyPress: function (val, e, field, options) {
      field.mask(maskCpfCnpj.apply({}, arguments), options);
    },
  };
  $('.cpf-cnpj').mask(maskCpfCnpj, optMaskCpfCnpj);

  // Telefone (Com 9 dígitos)
  const maskPhoneSP = function (val) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
  };
  const optMaskPhoneSP = {
    onKeyPress: function (val, e, field, options) {
      field.mask(maskPhoneSP.apply({}, arguments), options);
    },
    clearIfNotMatch: true,
  };
  $('.phone').mask(maskPhoneSP, optMaskPhoneSP);

  // Domínio
  $('.domain').on('input keydown keyup', function () {
    $(this).val($(this).val().toLowerCase().replace(/\s/g, ''));
  });
  // Domínio (Com ponto)
  $('.domain2').on('input keydown keyup', function () {
    $(this).val(
      $(this)
        .val()
        .toLowerCase()
        .replace(/www\.|http:\/\/|https:\/\//g, '')
        .replace(/\s|_/g, '-')
        .replace(/[^0-9a-z\-\.]/g, ''),
    );
  });
  // Domínio (Sem ponto)
  $('.domain3').on('input keydown keyup', function () {
    $(this).val(
      $(this)
        .val()
        .toLowerCase()
        .replace(/www\.|http:\/\/|https:\/\//g, '')
        .replace(/\s|_/g, '-')
        .replace(/[^0-9a-z\-]/g, ''),
    );
  });

  // SKU
  $('.sku').on('input keydown keyup', function () {
    $(this).val($(this).val().replace(/\s/g, ''));
  });

  // Peso
  $('.weight').mask('#0,000', { reverse: true });

  // Porcentagem
  $('.percent').mask('#0,00', { reverse: true });
}

// ------------------------------------
// Datepicker
// ------------------------------------
(function () {
  'use strict';

  // Tradução para o pluging 'Datepicker'
  const datepickerLocaleBR = {
    format: 'DD/MM/YYYY',
    separator: ' a ',
    applyLabel: 'Aplicar',
    cancelLabel: 'Limpar',
    fromLabel: 'De',
    toLabel: 'a',
    customRangeLabel: 'Outro período',
    daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    monthNames: [
      'Janeiro',
      'Fevereiro',
      'Março',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro',
    ],
  };

  // Datepicker
  $('.datepicker').each(function () {
    const openDirection = $(this).data('direction') && $(this).data('direction') === 'right' ? 'left' : 'right';
    const parentEl = $(this).data('parent') && $(this).data('parent') != '' ? $(this).data('parent') : 'body';
    $(this)
      .daterangepicker({
        singleDatePicker: true,
        autoUpdateInput: false,
        autoApply: true,
        parentEl: parentEl,
        opens: openDirection,
        locale: datepickerLocaleBR,
      })
      .on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY'));
        $(this).parsley().validate();
        $(this).parent().find('.input-group-clear').show();
      })
      .on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
        $(this).parsley().validate();
        $(this).parent().find('.input-group-clear').hide();
      });
  });

  // Datepicker Range
  $('.datepicker_range').each(function () {
    const openDirection = $(this).data('direction') && $(this).data('direction') === 'right' ? 'left' : 'right';
    const parentEl = $(this).data('parent') && $(this).data('parent') != '' ? $(this).data('parent') : 'body';
    $(this)
      .daterangepicker({
        autoUpdateInput: false,
        autoApply: true,
        parentEl: parentEl,
        opens: openDirection,
        locale: datepickerLocaleBR,
      })
      .on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY') + ' a ' + picker.endDate.format('DD/MM/YYYY'));
        $(this).parsley().validate();
        $(this).parent().find('.input-group-clear').show();
      })
      .on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
        $(this).parsley().validate();
        $(this).parent().find('.input-group-clear').hide();
      });
  });

  // Datepicker Range (Custom)
  $('.datepicker_range_custom').each(function () {
    const openDirection = $(this).data('direction') && $(this).data('direction') === 'right' ? 'left' : 'right';
    const parentEl = $(this).data('parent') && $(this).data('parent') != '' ? $(this).data('parent') : 'body';
    const rangeOpts = {
      autoUpdateInput: false,
      autoApply: true,
      parentEl: parentEl,
      opens: openDirection,
      locale: datepickerLocaleBR,
      minDate: moment().subtract(12, 'months'),
      ranges: {
        Hoje: [moment(), moment()],
        Ontem: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Últimos 7 dias': [moment().subtract(6, 'days'), moment()],
        'Últimos 30 dias': [moment().subtract(29, 'days'), moment()],
        'Este mês': [moment().startOf('month'), moment().endOf('month')],
      },
    };
    if ($(this).data('init-period')) {
      rangeOpts.minDate = moment(new Date($(this).data('init-period')), 'YYYY-MM-DD');
      rangeOpts.ranges['Todo o período'] = [moment(new Date($(this).data('init-period')), 'YYYY-MM-DD'), moment()];
    }
    $(this)
      .daterangepicker(rangeOpts)
      .on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY') + ' a ' + picker.endDate.format('DD/MM/YYYY'));
        $(this).parsley().validate();
        $(this).parent().find('.input-group-clear').show();
      })
      .on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
        $(this).parsley().validate();
        $(this).parent().find('.input-group-clear').hide();
      });
  });

  // Time Picker
  $('.timepicker').each(function () {
    const openDirection = $(this).data('direction') && $(this).data('direction') === 'right' ? 'left' : 'right';
    const timepickerLocaleBR = datepickerLocaleBR;
    timepickerLocaleBR.format = 'HH:mm';
    $(this)
      .daterangepicker({
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        autoUpdateInput: false,
        opens: openDirection,
        locale: datepickerLocaleBR,
      })
      .on('show.daterangepicker', function (ev, picker) {
        picker.container.addClass('timepicker');
      })
      .on('apply.daterangepicker', function (ev, picker) {
        $(this).val(picker.startDate.format(timepickerLocaleBR.format));
        $(this).parsley().validate();
        $(this).parent().find('.input-group-clear').show();
      })
      .on('cancel.daterangepicker', function (ev, picker) {
        $(this).val('');
        $(this).parsley().validate();
        $(this).parent().find('.input-group-clear').hide();
      });
  });

  // Limpa os campos de data
  $('.input-group-clear').on('click', function (ev) {
    ev.preventDefault();
    const $input = $($(this).data('input'));
    if ($input.length > 0) {
      const today = new Date();
      const picker = $input.data('daterangepicker');
      picker.setStartDate(today);
      picker.setEndDate(today);
      $input.val('');
      $input.parsley().validate();
      $(this).hide();
    }
  });
})();

// ------------------------------------
// Select2
// ------------------------------------
(function () {
  'use strict';

  !(function (e) {
    var r = e.fn.select2.amd.require('select2/defaults');
    e.extend(r.defaults, { searchInputPlaceholder: '' });
    var t = e.fn.select2.amd.require('select2/dropdown/search'),
      a = t.prototype.render;
    t.prototype.render = function (e) {
      var r = a.apply(this, Array.prototype.slice.apply(arguments));
      return this.$search.attr('placeholder', this.options.get('searchInputPlaceholder')), r;
    };
  })(window.jQuery);

  // Campos
  const $inputs = $('.select2');

  // Aplica o plugin nos campos
  $inputs.each(function () {
    const $input = $(this);
    const maximumSelectionLength = $input.data('max') ? parseInt($input.data('max')) : 0;
    const placeholder = $input.data('placeholder') ? $input.data('placeholder') : false;
    const search = $input.data('search') ? true : false;
    const searchPlaceholder = $input.data('src-placeholder') ? $input.data('src-placeholder') : 'Pesquisar...';
    const options = {
      width: '100%',
      language: 'pt-BR',
      maximumSelectionLength: maximumSelectionLength,
      searchInputPlaceholder: searchPlaceholder,
    };
    if (!search) {
      options.minimumResultsForSearch = -1;
    }
    if (placeholder) {
      options.placeholder = placeholder;
    }
    $input.select2(options).on('change.select2', function (ev) {
      $(ev.currentTarget).parsley().validate();
    });
  });
})();

// SELECT 2 (AJAX)
initSelect2Ajax();
function initSelect2Ajax() {
  // Campos
  $('.select2-ajax').each(function () {
    const $input = $(this);
    const maximumSelectionLength = $input.data('max') ? parseInt($input.data('max')) : 0;
    const placeholder = $input.data('placeholder') ? $input.data('placeholder') : false;
    const search = $input.data('search') ? true : false;
    const searchPlaceholder = $input.data('src-placeholder') ? $input.data('src-placeholder') : 'Pesquisar...';
    const options = {
      width: '100%',
      language: 'pt-BR',
      maximumSelectionLength: maximumSelectionLength,
      searchInputPlaceholder: searchPlaceholder,
      templateResult: formatItemOpt,
      templateSelection: formatItemOpt,
    };
    // Item com imagem
    let itemWithImg = $input.data('with-img');
    if (itemWithImg) {
      options.containerCssClass = 'select2-with-img';
    }
    // Ajax com scroll infinito
    const url = $input.data('url');
    if (url) {
      // Itens por página/scroll
      const itensPerPage = $input.data('perpage') || 30;
      // Parâmetros adicionais
      const paramsAdd = $input.data('params') || {};
      options.ajax = {
        url: url,
        dataType: 'json',
        type: 'GET',
        delay: 250,
        cache: true,
        data: function (params) {
          var query = {
            term: params.term,
            page: params.page || 1,
          };
          if (typeof paramsAdd === 'object' && Object.keys(paramsAdd).length > 0) {
            Object.keys(paramsAdd).forEach((paramAdd) => {
              query[paramAdd] = paramsAdd[paramAdd];
            });
          }
          return query;
        },
        processResults: function (data, params) {
          params.page = params.page || 1;
          return {
            results: data.results,
            pagination: {
              more: params.page * itensPerPage < data.total_count,
            },
          };
        },
      };
      options.minimumInputLength = 3;
      options.escapeMarkup = function (markup) {
        return markup;
      };
      // Valor inicial (Ajax)
      const initialVal = $input.data('value') || false;
      if (initialVal) {
        $.getJSON(`${url}?cur_id=${initialVal}`, function (resp) {
          if (resp.total_count > 0) {
            const curItem = resp.results[0];
            const initOption = new Option(curItem.text, curItem.id, true, true);
            if (itemWithImg && curItem?.image) {
              initOption.image = curItem.image;
            }
            $input.append(initOption).trigger('change');
          }
        });
      }
    }
    if (!search) {
      options.minimumResultsForSearch = -1;
    }
    if (placeholder) {
      options.placeholder = placeholder;
    }
    // Evento para alteração
    $input.select2(options).on('change.select2-ajax', function (ev) {
      $(ev.currentTarget).parsley().validate();
    });
    // Formata o item para seleção
    function formatItemOpt(opt) {
      if (!opt.id) {
        return opt.text;
      }
      let optImg = opt?.image;
      if (opt?.element?.image) {
        optImg = opt.element.image;
      }
      if (optImg && itemWithImg) {
        const $opt = $(
          `<div class="select2-cus-item"><img src="${optImg}" class="img-fluid rounded border select2-cus-item-img" width="35px" height="35px"><div class="truncate-text select2-cus-item-tit">${opt.text}</div></div>`,
        );
        return $opt;
      } else {
        const $opt = $(
          `<div class="select2-cus-item"><div class="truncate-text select2-cus-item-tit">${opt.text}</div></div>`,
        );
        return $opt;
      }
    }
  });
}

// ------------------------------------
// Validação (Parsley)
// ------------------------------------
(function () {
  'use strict';

  // Inicia o validador
  $('.form-validation').parsley({
    errorClass: 'is-invalid',
    successClass: 'is-valid',
    classHandler: function (el) {
      return el.$element.closest('.form-group');
    },
    errorsContainer: function (el) {
      return el.$element.closest('.form-group');
    },
  });

  // Nome completo
  window.Parsley.addValidator('fullname', {
    validateString: function (value) {
      var value = value.trim().split(' ');
      return value.length > 1;
    },
    messages: {
      'pt-br': 'Digite o nome completo.',
    },
  });

  // Valida CPF
  window.Parsley.addValidator('cpf', {
    validateString: function (value) {
      return isValidCPF(value);
    },
    messages: {
      'pt-br': 'Digite um número de CPF válido.',
    },
  });

  // Valida CNPJ
  window.Parsley.addValidator('cnpj', {
    validateString: function (value) {
      return isValidCNPJ(value);
    },
    messages: {
      'pt-br': 'Digite um número de CNPJ válido.',
    },
  });

  // Valida CPF ou CNPJ
  window.Parsley.addValidator('cpf_cnpj', {
    validateString: function (value) {
      return isValidCPForCNPJ(value);
    },
    messages: {
      'pt-br': 'Digite um número de CPF ou CNPJ válido.',
    },
  });

  // Valida Telefone
  window.Parsley.addValidator('phone', {
    validateString: function (value) {
      return isValidPhone(value);
    },
    messages: {
      'pt-br': 'Digite um número de telefone válido.',
    },
  });

  // Valida data
  window.Parsley.addValidator('date', {
    validateString: function (value) {
      return isValidDate(value);
    },
    messages: {
      'pt-br': 'Digite uma data válida.',
    },
  });

  // Valida data de nascimento
  window.Parsley.addValidator('birth', {
    validateString: function (value) {
      return isValidDate(value, true);
    },
    messages: {
      'pt-br': 'Digite uma data válida.',
    },
  });

  // Tamanho do arquivo
  window.Parsley.addValidator('maxfilesize', {
    validateString: function (value, maxSize, parsleyInstance) {
      maxSize = maxSize * 1048576;
      const input = parsleyInstance.$element[0];
      const files = input.files;
      const file = files[0];
      if (files.length == 1 && file.size <= maxSize) {
        return true;
      }
      input.value = '';
      return false;
    },
    requirementType: 'integer',
    messages: {
      'pt-br': 'O arquivo não deve ser maior que %s MB.',
    },
  });

  // Validação externa (Ex: E-mail já cadastrado no sistema)
  window.Parsley.addAsyncValidator('remote', function (resp) {
    console.log(resp.responseText);
    //console.log('Validação externa: ' + resp.responseText);
    return resp.responseText == 'success';
  });

  // Limite de itens separados por vírgula
  window.Parsley.addValidator('maxitens', {
    validateString: function (value, limit) {
      return value.split(',').length <= limit;
    },
    requirementType: 'integer',
    messages: {
      'pt-br': 'Informe no máximo %s itens.',
    },
  });

  // Valida múltiplos e-mails (separados por vírgula)
  window.Parsley.addValidator('emailsmult', {
    validateString: function (value) {
      const itens = value.split(',');
      const itensLength = itens.length;
      for (let i = 0; i < itensLength; i++) {
        if (!isValidEmail(itens[i].trim())) {
          return false;
        }
      }
      return true;
    },
    requirementType: 'integer',
    messages: {
      'pt-br': 'Informe apenas endereços de e-mail válidos.',
    },
  });

  // Valida o valor mínimo do campo
  /* window.Parsley.addValidator('minval', {
    validateString: function (value, limit) {
      value = Number(formatMoneyBD(value));
      return $.Deferred().reject('custom message');
      return value >= limit;
    },
    requirementType: 'number',
    messages: {
      'pt-br': 'O valor deve ser de no mínimo R$ %s.',
    },
  }); */

  // Valida o valor máximo do campo
  /* window.Parsley.addValidator('maxval', {
    validateString: function (value, limit) {
      value = Number(formatMoneyBD(value));
      return value <= limit;
    },
    requirementType: 'number',
    messages: {
      'pt-br': 'O valor deve ser de no máximo R$ %s.',
    },
  }); */

  // Valida o número do cartão
  window.Parsley.addValidator('luhn', {
    validateString: function (value) {
      let cardNumber = somenteNumeros(value);
      /*  if (cardNumber.length) {
        return true;
      } */
      return luhnValidate(cardNumber);
    },
    messages: {
      'pt-br': 'Digite um número válido',
    },
  });
})();

// ------------------------------------
// Campos dinâmicos
// ------------------------------------
(function () {
  'use strict';

  // Desativa o cache do Ajax
  $.ajaxSetup({ cache: false });

  // Campos dinâmicos
  $('[data-sync-input]').each(function () {
    // Variáveis

    // Campo dinâmico
    const $input = $(this);
    // Campo relativo
    const $relativeInput = $($input.data('sync-input'));
    // Parâmetro do campo relativo
    const parentParam = $input.data('sync-param');
    // URL da ação
    let url = $input.data('sync-url').includes('?')
      ? `${$input.data('sync-url')}&${parentParam}=`
      : `${$input.data('sync-url')}?${parentParam}=`;
    // Valor cadastrado do campo dinâmico (Update)
    const inputValue = $input.data('sync-value');
    // Parâmetro que ficará no atributo "value" de cada "<option>"
    const optionValue = $input.data('sync-option-value');
    // Parâmetro que ficará dentro de cada "<option>"
    const optionText = $input.data('sync-option-text');
    // Placeholder exibido no campo dinâmico, após o carregamento
    const inputPlaceholder = $input.data('sync-placeholder');

    // Carrega o campo dinâmico ao carregar a página
    loadSyncInput();

    // Evento de alteração do campo relativo
    $relativeInput.on('change', loadSyncInput);

    // Carrega o campo dinâmico
    function loadSyncInput() {
      processingSync();
      // Realiza a requisição dos dados
      $.getJSON(`${url}${$relativeInput.val()}`, function (result) {
        console.log(result);
        if (Array.isArray(result) && result.length > 0) {
          populateInput(result);
        } else {
          resetInput();
        }
        //input.trigger('change');
      }).fail(errorInput);
    }

    // Popula o campo dinâmico com os dados retornados
    function populateInput(list) {
      $input.html('');
      changePlaceholder(inputPlaceholder);
      for (let i = 0, n = list.length; i < n; i++) {
        const selected = inputValue == list[i][optionValue] ? 'selected' : '';
        $input.append(`<option value="${list[i][optionValue]}" ${selected}>${list[i][optionText]}</option>`);
      }
      $input.prop('disabled', false);
      if ($input.attr('id') === 'variante_oferta') {
        handleVariantMkt(list);
      }
    }

    // Ações executadas enquanto a requisição é processada
    function processingSync() {
      $input.prop('disabled', true);
      $input.html('');
      changePlaceholder('Aguarde...');
    }

    // Reseta o campo dinâmico
    function resetInput() {
      $input.html('');
      changePlaceholder(inputPlaceholder);
      $input.prop('disabled', false);
    }

    // Erro na requisição
    function errorInput(resp) {
      console.log(resp);
      resetInput();
    }

    // Altera o placeholder do campo dinâmico
    function changePlaceholder(text) {
      // Select2
      if ($input.hasClass('select2')) {
        $input.append(`<option></option>`);
        setTimeout(() => {
          $(`#select2-${$input.attr('id')}-container .select2-selection__placeholder`).text(text);
        });
      }
      // Select Padrão
      else {
        $input.append(`<option value="" hidden>${text}</option>`);
      }
    }

    function handleVariantMkt(list) {
      const $varOferWrp = $('.variant-ofer-wrp');
      let hasUnique = list.some((item) => {
        return item.slug === 'u';
      });
      let varUnique;
      if (list.length > 1) {
        if (hasUnique) {
          varUnique = list.filter((item) => {
            return item.slug === 'u';
          })[0];
          $input.val(varUnique.sku).trigger('change').parsley().reset();
          $varOferWrp.hide();
        } else {
          if (!optionValue) {
            $input.val('').trigger('change').parsley().reset();
          }
          $varOferWrp.show();
        }
      } else {
        $varOferWrp.hide();
      }
    }
  });
})();

// ------------------------------------
// Completa Endereço
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const urlApi = urlBase + 'core/acoes/app/geral/completa_endereco.php';
  const $ceps = $('.compl-cep');

  $ceps.each(function () {
    // Variáveis
    const $cep = $(this);
    const $cepLoader = $cep.next('.btn-spinner-input');
    const $inputWrapper = $($cep.data('wrp'));
    const $logradouro = $($cep.data('logradouro'));
    const $numero = $($cep.data('numero'));
    const $bairro = $($cep.data('bairro'));
    const $cidade = $($cep.data('cidade'));
    const $estado = $($cep.data('estado'));
    //const $allAddressInput = $('[class*="compl-"]');
    let address = {};

    // Executa a ação quando o CEP é alterado
    $cep.on('input', function () {
      const cepLength = $(this).val().replace(/\D/g, '').length;
      if (cepLength >= 8) {
        getAddress();
      } else {
        if ($inputWrapper.length > 0) {
          $inputWrapper.slideUp();
        }
      }
    });

    // Obtém o endereço completo
    function getAddress() {
      processingAddress();
      // Realiza a requisição dos dados
      $.getJSON(`${urlApi}?cep=${$cep.val()}`, function (result) {
        console.log(result);
        finishedAddress();
        if (result.logradouro) {
          address = result;
          populateAddress();
        } else {
          // CEP não encontrado
          console.log('Não foi possível obter o endereço. Verifique o CEP informado.');
          showInputs();
        }
      }).fail(errorAddress);
    }

    // Popula os campos do endereço
    function populateAddress() {
      $cep.parsley().validate();
      if ($logradouro.length > 0) {
        $logradouro.val(address.logradouro).trigger('change');
        $logradouro.parsley().validate();
      }
      if ($bairro.length > 0) {
        $bairro.val(address.bairro).trigger('change');
        $bairro.parsley().validate();
      }
      if ($cidade.length > 0) {
        $cidade.val(address.cidade).trigger('change');
        $cidade.parsley().validate();
      }
      if ($estado.length > 0) {
        $estado.val(address.uf).trigger('change');
        $estado.parsley().validate();
      }
      showInputs();
      $cep.trigger('loaded-address');
    }

    // Ações executadas enquanto a requisição é processada
    function processingAddress() {
      $cepLoader.removeClass('d-none');
      //$allAddressInput.prop('disabled', true);
    }

    // Ações executadas quanto a requisição é finalizada
    function finishedAddress() {
      $cepLoader.addClass('d-none');
      showInputs();
      //$allAddressInput.prop('disabled', false);
    }

    // Erro na requisição do endereço
    function errorAddress(resp) {
      finishedAddress();
      console.log(resp);
    }

    // Exibe campos do endereço
    function showInputs() {
      if ($inputWrapper.length > 0) {
        $inputWrapper.slideDown(function () {
          if ($numero.length > 0) {
            $numero.focus();
          }
        });
      } else {
        if ($numero.length > 0) {
          $numero.focus();
        }
      }
    }
  });
})();

// ------------------------------------
// Contador de Caracteres
// ------------------------------------
(function () {
  'use strict';

  // Campos
  const $inputs = $('.form-control[data-char-count]');

  // Contador
  $inputs.each(function () {
    const $input = $(this);
    const limit = $input.attr('maxlength');
    let count = $input.val().length;
    $input.after('<div class="char-counter"></div>');
    const $countEl = $input.next('.char-counter');
    $countEl.text(count + '/' + limit);
    validateLimit();
    $input.on('keyup keydown keypress', function () {
      count = $(this).val().length;
      $countEl.text(count + '/' + limit);
      validateLimit();
    });
    function validateLimit() {
      if (count >= limit) {
        $countEl.addClass('invalid');
      } else {
        $countEl.removeClass('invalid');
      }
    }
  });
})();

// ------------------------------------
// Exibir Senha
// ------------------------------------
(function () {
  'use strict';

  // Exibe ou oculta o valor do campo de senha
  $('.show-password').on('click', function () {
    const $element = $(this);
    const $iconEl = $element.children('.las');
    const $input = $element.next('.form-control');
    $element.toggleClass('active');
    if ($element.hasClass('active')) {
      $iconEl.removeClass('la-eye');
      $iconEl.addClass('la-eye-slash');
      $input.attr('type', 'text');
    } else {
      $iconEl.removeClass('la-eye-slash');
      $iconEl.addClass('la-eye');
      $input.attr('type', 'password');
    }
  });
})();

// ------------------------------------
// Color Picker
// ------------------------------------
(function () {
  'use strict';
  // Deve ser chamado quando um input colorpicker é criado dinâmicamente
  $(document).on('input.colorpicker.dinamico', function (ev, itemId) {
    if (itemId) {
      try {
        $(`#${itemId}`)
          .colorpicker({
            format: 'hex',
          })
          .on('colorpickerChange', function (event) {
            const element = $(event.target);
            const color = event.color ? event.color.toString() : 'black';
            // element.parent().find('.colorpicker-input-addon i').css('color', color);
            element.parent().find('.input-group-text i').css('color', color);
            // element.children('input').parsley().validate();
          });
      } catch (e) {
        console.log(e);
      }
    }
  });
  $('.input-colorpicker')
    .colorpicker({
      format: 'hex',
    })
    .on('colorpickerChange', function (event) {
      const element = $(event.target);
      const color = event.color ? event.color.toString() : 'black';
      // element.parent().find('.colorpicker-input-addon i').css('color', color);
      element.parent().find('.input-group-text i').css('color', color);
      // element.children('input').parsley().validate();
    });
  $('body').on('click', '.my-colorpicker2 .input-group-text', function () {
    $(this).parent().parent().find('.input-colorpicker').focus();
  });
})();

// ------------------------------------
// Tags Input
// ------------------------------------
initTagsInput();
function initTagsInput() {
  $('input.tags').tagsinput('destroy');
  $('input.tags').each(function () {
    const $el = $(this);
    const maxTags = $el.data('parsley-maxitens') ? Number($el.data('parsley-maxitens')) : undefined;
    $el.tagsinput({
      delimiter: [','],
      maxTags: maxTags,
      trimValue: true,
    });
    $el.on('itemAdded itemRemoved', function (event) {
      $(event.target).parsley().validate();
    });
  });
}

// ------------------------------------
//  Altera o texto do switch
// ------------------------------------
(function () {
  'use strict';
  $('.form-switch[data-swt-true]').each(function () {
    const $switch = $(this);
    const $switchSlider = $switch.find('.form-switch-slider');
    const txtTrue = $switch.data('swt-true');
    const txtFalse = $switch.data('swt-false');
    const txtTrueWidth = measureText(txtTrue, 10, 600);
    const txtFalseWidth = measureText(txtFalse, 10, 600);
    const $txtTrue = $('<span class="form-switch-text true">' + txtTrue + '</span>');
    const $txtFalse = $('<span class="form-switch-text false">' + txtFalse + '</span>');
    const widthBigger = Math.max(txtTrueWidth, txtFalseWidth);
    $switchSlider.css('width', widthBigger + 45);
    $switchSlider.append($txtTrue);
    $switchSlider.append($txtFalse);
  });
})();

// ------------------------------------
// Campo FontAwesome
// ------------------------------------
(function () {
  'use strict';
  $('[data-fa-update]').each(function () {
    const input = $(this);
    const icon = $(`[data-fa-input="#${input.attr('id')}"]`);
    input.on('change keyup', updateIcon);
    updateIcon();
    function updateIcon() {
      const iconClass = input.val() != '' ? input.val() : 'far fa-circle';
      icon.removeClass();
      icon.addClass(iconClass);
    }
  });
})();

// ------------------------------------
// Exibe campos com base no checkbox
// ------------------------------------
(function () {
  'use strict';
  if ($('[data-div-check-wrp]').length > 0) {
    handleInputs();
    $('[data-div-check-wrp]').on('change', handleInputs);
    function handleInputs() {
      $('[data-div-check-wrp]').each(function () {
        const $input = $(this);
        const inputName = $input.attr('name');
        const $inputChecked = $('[data-div-check-wrp][name="' + inputName + '"]:checked');
        const $wrpAll = $($input.data('div-check-wrp'));
        $wrpAll.each(function () {
          const $wrp = $(this);
          const conditionV = $wrp.data('condition');
          const $wrpInputs = $wrp.find('input, select, textarea');
          const conditionVerify = !conditionV ? $input.is(':checked') : $inputChecked.val() == conditionV;
          if (conditionVerify) {
            //$wrpInputs.prop('required', true);
            $wrp.slideDown();
          } else {
            $wrp.slideUp();
            $wrpInputs.prop('required', false);
          }
        });
      });
    }
  }

  // Transportadoras Kangu
  if ($('.kangu_trans_cat').length) {
    $('.kangu_trans_cat').on('change', handleKanguTransCat);
    //handleKanguTransCat();
    function handleKanguTransCat(ev) {
      const $input = $(ev.target);
      const $inputSubsWrp = $($input.data('div-check-wrp'));
      const $inputSubs = $inputSubsWrp.find('.form-check-input');
      if ($input.is(':checked')) {
        $inputSubs.prop('checked', true).trigger('change');
      } else {
        $inputSubs.prop('checked', false).trigger('change');
      }
    }
  }
})();

// ------------------------------------
// Exibe um campo dependendo de outro marcado
// ------------------------------------
(function () {
  'use strict';

  const $inputs = $('.input-depend');
  $inputs.on('change depend-change', function () {
    inputDependHandler($(this));
  });
  function inputDependHandler($input) {
    const isCheckbox = $input.attr('type') === 'checkbox';
    const inputID = $input.attr('id');
    let value = $input.val();
    if (isCheckbox) {
      value = $input.is(':checked') ? '1' : '0';
    }
    const $inputs = $(`[data-depend-input="#${inputID}"]`);
    $inputs.hide();
    $inputs.each(function () {
      let values = $(this).data('depend-value');
      values = typeof values === 'number' ? values.toString() : values;
      values = values.split(',');
      if (values.indexOf(value) !== -1) {
        $(this).show();
      }
    });
  }
})();

// ------------------------------------
// Ezdz (Upload de imagem única)
// ------------------------------------
(function () {
  'use strict';

  // Campos
  const $inputs = $('input.ezdz');

  // Aplica o plugin nos campos
  $inputs.each(aplicaPluginEzdz);
  $(document).on('input.ezdz.dinamico', function (ev, inputId) {
    if (inputId) {
      try {
        aplicaPluginEzdz.call($(`#${inputId}`));
      } catch (e) {
        console.log(e);
      }
    }
  });
  function aplicaPluginEzdz() {
    // Variáveis
    const $input = $(this);
    let $dropzone;
    const text = $input.data('ezdz-text') ? $input.data('ezdz-text') : 'Selecionar imagem';
    const maxWidth = $input.data('ezdz-maxwidth') ? parseInt($input.data('ezdz-maxwidth')) : null;
    const maxHeight = $input.data('ezdz-maxheight') ? parseInt($input.data('ezdz-maxheight')) : null;
    const maxSizeMb = $input.data('ezdz-maxsize') ? parseInt($input.data('ezdz-maxsize')) : 10;
    // Mensagens de erro
    const messagesList = {
      mimeType: 'Selecione uma imagem válida.',
      maxSize: `A imagem não deve ser maior que ${maxSizeMb} MB.`,
      maxWidth: `Selecione uma imagem com até ${maxWidth}px de largura.`,
      maxHeight: `Selecione uma imagem com até ${maxHeight}px de altura.`,
    };

    // Converte MB em Bytes
    const maxSize = maxSizeMb * 1048576;

    // Aplica o plugin ao campo
    $input.ezdz({
      text: text, // Texto
      validators: {
        maxSize: maxSize, // Tamanho máximo (MB)
        maxWidth: maxWidth, // Largura máxima
        maxHeight: maxHeight, // Altura máxima
      },
      // Inicializa o plugin
      init: function () {
        $dropzone = $input.parent('.ezdz-dropzone');
      },
      // Imagem inválida
      reject: function (file, errors) {
        const error = getEzdzError(messagesList, errors);
        $dropzone.addClass('ezdz-reject');
        $input.parsley().removeError('ezdz-error', { updateClass: true });
        $input.parsley().addError('ezdz-error', { message: error, updateClass: true });
      },
      // Imagem válida
      accept: function (file) {
        $dropzone.removeClass('ezdz-reject');
        $input.parsley().removeError('ezdz-error', { updateClass: true });
      },
    });
  }

  // Retorna a mensagem relacionada ao erro
  function getEzdzError(messagesList, errosList) {
    for (let error in errosList) {
      if (errosList[error]) {
        return messagesList[error];
      }
    }
    return false;
  }
})();

// Campo clipboard
(function () {
  'use strict';
  const $btnCopy = $('.btn-clipboard');
  $btnCopy
    .on('click', function (ev) {
      ev.preventDefault();
    })
    .on('mouseout', function () {
      const $btn = $(this);
      $btn.attr('data-original-title', 'Copiar');
    });
  const clipboardOpts = {};
  if ($btnCopy.data('modal')) {
    clipboardOpts['container'] = $($btnCopy.data('modal'))[0];
  }
  const clipboardBtn = new ClipboardJS('.btn-clipboard', clipboardOpts);
  clipboardBtn.on('success', function (ev) {
    const $btn = $(ev.trigger);
    $btn.attr('data-original-title', 'Copiado!');
    $btn.tooltip('show');
  });
})();

// Campo clipboard (Modal)
(function () {
  'use strict';
  const $btnCopy = $('.btn-clipboard-modal');
  $btnCopy
    .on('click', function (ev) {
      ev.preventDefault();
    })
    .on('mouseout', function () {
      const $btn = $(this);
      $btn.attr('data-original-title', 'Copiar');
    });
  const clipboardOpts = {};
  if ($btnCopy.data('modal')) {
    clipboardOpts['container'] = $($btnCopy.data('modal'))[0];
  }
  clipboardOpts.text = function (trigger) {
    return $(trigger).data('clipboard-text');
  };
  const clipboardBtn = new ClipboardJS('.btn-clipboard-modal', clipboardOpts);
  clipboardBtn.on('success', function (ev) {
    const $btn = $(ev.trigger);
    $btn.attr('data-original-title', 'Copiado!');
    $btn.tooltip('show');
  });
})();

// Editor de código
(function () {
  'use strict';
  $('.code-editor').each(function () {
    const $input = $(this);
    const editor = CodeMirror.fromTextArea($input[0], {
      mode: 'htmlmixed',
      lineNumbers: true,
      smartIndent: true,
      matchBrackets: true,
      lineWrapping: true,
      indentWithTabs: true,
      tabSize: 2,
    });
    //editor.setSize('auto', '150px');
    editor.on('change', function () {
      $input.val(editor.getValue());
    });
  });
})();
